import { diff as DiffEditor } from 'react-ace';
import { config } from 'ace-builds';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-tomorrow';
import 'ace-builds/src-noconflict/theme-tomorrow_night';
import workerJsonUrl from 'ace-builds/src-noconflict/worker-json?url';
import { useIntl } from 'react-intl';
import { Box, Typography, useTheme } from '@rossum/ui/material';

config.setModuleUrl('ace/mode/json_worker', workerJsonUrl);

type SchemaDiffEditorProps = {
  localValue: string;
  remoteValue: string;
};

export const SchemaDiffEditor = ({
  localValue,
  remoteValue,
}: SchemaDiffEditorProps) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <Typography
          variant="caption"
          sx={{ flex: 1, px: 2, py: 0.5, fontWeight: 'bold' }}
        >
          {intl.formatMessage({ id: 'components.editor.diff.yourChanges' })}
        </Typography>
        <Typography
          variant="caption"
          sx={{ flex: 1, px: 2, py: 0.5, fontWeight: 'bold' }}
        >
          {intl.formatMessage({ id: 'components.editor.diff.remoteVersion' })}
        </Typography>
      </Box>
      <Box sx={{ flex: 1 }}>
        <DiffEditor
          value={[localValue, remoteValue]}
          mode="json"
          theme={theme.palette.mode === 'light' ? 'tomorrow' : 'tomorrow_night'}
          width="100%"
          height="100%"
          fontSize={14}
          showGutter
          highlightActiveLine={false}
          readOnly
          tabSize={2}
          wrapEnabled={false}
          setOptions={{
            useWorker: true,
            showLineNumbers: true,
          }}
        />
      </Box>
    </Box>
  );
};
